import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { paymentStatusName } from "../../utils/paymentStatusNames";

interface OrderPaymentStatusCellProps {
  status?: GraphQL.PaymentStatus | null;
}

export const OrderPaymentStatusCell: React.FC<OrderPaymentStatusCellProps> = ({ status }) => {
  if (!status) return <></>;
  return <>{paymentStatusName(status)}</>;
};
